"use client";
import { ProcessedCourse } from "@/common/course/types";
import CourseBadges, {
  CourseBadge,
} from "@/components/CourseContent/CourseBadges";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import {
  ExecEdATFTestResult,
  HeroBadgesPosition,
} from "@/monarch/rules/execEdATF/types";
import { ExecEdDetailPageTestResult } from "@/monarch/rules/execEdDetailPageTest/types";
import { getBadgesByProductUuid } from "../../utls/badges";

interface HeroBadgesProps {
  course: ProcessedCourse;
  position: HeroBadgesPosition;
}

export default function HeroBadges({ course, position }: HeroBadgesProps) {
  const badges = getBadgesByProductUuid(course);
  return (
    <MonarchDataConsumer<ExecEdDetailPageTestResult>
      experimentKey="useExecEdDetailPageTest"
      render={(testResult) => {
        const { data } = testResult;
        const hasTestData = data?.heroBadges?.badges?.length;

        if (
          !hasTestData &&
          badges &&
          badges.badges.length &&
          position === badges.position
        ) {
          return (
            <CourseBadges
              course={course}
              badges={badges?.badges}
              className={position === "above-subheader" ? "mb-3" : "mt-3"}
            />
          );
        }

        if (
          data?.heroBadges?.position !== position ||
          !data?.heroBadges?.badges ||
          data.heroBadges.badges.length === 0
        ) {
          return null;
        }

        return (
          <CourseBadges
            course={course}
            badges={data.heroBadges.badges}
            className={position === "above-subheader" ? "mb-3" : "mt-3"}
          />
        );
      }}
    />
  );
}
